export default __webpack_public_path__ + "static/media/course-sample5.87ab4bec.png";